import React, { Component } from 'react';
import Modal from "react-responsive-modal";


const WallpaperPreviewModal=({imageUrl,onCloseModal,isModalOpen,downloadImageFromURL})=>{
    let customStyles={
        customModal:{
            background:'black'
        }
    }

    return(
            <Modal open={isModalOpen} onClose={onCloseModal}
            classNames={{
                modal: "customModal",
                closeButton:"customCloseButton",
                closeIcon:"customCloseIcon"
              }}
             onOverlayClick={onCloseModal} center>
                <div className="wallpaperPreview">
                    <img src={imageUrl} className="wallpaperImage" />
                    <div className="downloadButton-contaoner">
                        <button className="downloadButton" onClick={()=>downloadImageFromURL(imageUrl)}>download</button>
                    </div>
                </div>
            </Modal>
    )
}
export default WallpaperPreviewModal;


// WEBPACK FOOTER //
// ./src/components/wallpapers/wallpaperPreviewModal.js